const READY = "CLIENT_READY"
const SENDING_ENV = "SCRIPT_SENDING_ENV_VARIABLES_TO_CLIENT"
const RUNNING_SCRIPT = "CLIENT_RUNNING_CREATE_TENANT_AND_USERS"
const SUCCESS = "CLIENT_SUCCESSFULLY_CREATED_TENANT_AND_USERS"
const ERROR = "ERROR"

module.exports = {
  READY,
  SENDING_ENV,
  RUNNING_SCRIPT,
  SUCCESS,
  ERROR
}